import Image from 'next/legacy/image'

import { SEO, Section, Text } from '@components'
import CommonPageLayout from '@layouts/CommonPageLayout'

import styles from './style.module.css'

import { useIsWidthLarger } from '@utils/hooks'
import qualityContent from '@constants/quality'

function QualityModule() {
  const isMedium = useIsWidthLarger(768)

  return (
    <>
      <SEO
        title='BASE Skincare Quality'
        description='Kecantikan Vegan Berkualitas Tertinggi: Bahan Efektif, Aman, dan Ramah Lingkungan, untuk Kulitmu yang Lebih Sehat.'
      />

      <Section className={styles.heroContainer}>
        {isMedium && (
          <Image
            alt="Base Quality"
            src="https://static.base.co.id/background-quality-page.png"
            layout="fill"
            objectFit="cover"
            objectPosition="100% 100%"
          />
        )}

        <div className={styles.heroTextContainer}>
          <Text
            tag="h1"
            variant="title"
            color={isMedium ? 'white' : 'black'}
            className={styles.heroTitle}
          >
            We make the products we want to use.
          </Text>

          <Text
            tag="h2"
            variant="heroDescription"
            color={isMedium ? 'white' : 'black'}
          >
            We only choose the ingredients we&apos;d want to use on our own
            skin. We make sure they&apos;re of exceptional quality,
            ethically-produced and sourced, and free from harmful ingredients
            like parabens, dyes, perfumes, phthalates, sulfates and GMOs.
          </Text>
        </div>
      </Section>

      <Section className={styles.qualityContainer}>
        {qualityContent.map((content, index) => (
          <div key={`quality_${index}`} className={styles.qualityContent}>
            <div className={styles.contentText}>
              <Text variant="subtitle">{content.title}</Text>

              <Text>{content.text}</Text>
            </div>

            <div className={styles.contentImageContainer}>
              <Image
                alt={content.title}
                src={content.img}
                layout="responsive"
                height={content.imageHeight}
                width={content.imageWidth}
              />
            </div>
          </div>
        ))}
      </Section>
    </>
  )
}

QualityModule.getLayout = page => {
  return (
    <CommonPageLayout containerClassName={styles.container}>
      {page}
    </CommonPageLayout>
  )
}

export default QualityModule
